// Room pages — each groups the renovation spaces for one physical room.
// Layout rule from the owner: bathroom section first, then bedroom.
// A section points at an existing space doc (spaces/{spaceId}), so files,
// moodboards, lists and the new view boards all live where they always did.

// Technical view tabs shown inside every room section. Each view is a doc at
// spaces/{spaceId}/views/{viewId} — { tiles: [...], notes } — created lazily
// on first write. Add/remove/rename a tab here; no data migration needed.
export const VIEW_TABS = [
  { id: 'render', label: 'Full render' },
  { id: 'blueprint', label: 'Blueprints' },
  { id: 'dimensions', label: 'Dimensions' },
  { id: 'studs', label: 'Studs & framing' },
  { id: 'electrical', label: 'Electrical' },
  { id: 'plumbing', label: 'Plumbing' },
  { id: 'moodboards', label: 'Moodboards' }, // embeds the space's existing boards
];

// previewS3Key: hero image for the room's card on the homepage — points at a
// design-library key in the raw bucket (render options / style boards).
export const ROOMS = [
  {
    id: 'master',
    name: 'Master',
    icon: '🌅',
    blurb: 'Master suite — bath and bedroom.',
    previewS3Key: 'spaces/design-library/bathrooms/bath-bali-1.jpg',
    sections: [
      { label: 'Master Bath', spaceId: 'bathroom-1' },
      { label: 'Master Room', spaceId: 'bedroom-1' },
    ],
  },
  {
    id: 'east-room',
    name: 'East Room',
    icon: '🌇',
    blurb: 'East wing — bathroom and bedroom.',
    previewS3Key: 'spaces/design-library/renders/east-bali-light.jpg',
    sections: [
      { label: 'Bathroom', spaceId: 'bathroom-2' },
      { label: 'Bedroom', spaceId: 'bedroom-2' },
    ],
  },
  {
    id: 'south-room',
    name: 'South Room',
    icon: '🌴',
    blurb: 'South wing — bathroom and bedroom.',
    previewS3Key: 'spaces/design-library/renders/south-bali-light.jpg',
    sections: [
      { label: 'Bathroom', spaceId: 'bathroom-3' },
      { label: 'Bedroom', spaceId: 'bedroom-3' },
    ],
  },
  {
    id: 'north-room',
    name: 'North Room',
    icon: '🌊',
    blurb: 'North wing — bathroom and bedroom.',
    previewS3Key: 'spaces/design-library/renders/north-bali-stone.jpg',
    sections: [
      { label: 'Bathroom', spaceId: 'bathroom-4' },
      { label: 'Bedroom', spaceId: 'bedroom-4' },
    ],
  },
  {
    id: 'entrance-bathroom',
    name: 'Entrance Bathroom',
    icon: '🚪',
    blurb: 'Off the living room — sink, cabinet and toilet.',
    previewS3Key: 'spaces/design-library/bathrooms/pr-bali.jpg',
    sections: [{ label: 'Bathroom', spaceId: 'powder-room' }],
  },
];

export const roomById = (id) => ROOMS.find((r) => r.id === id) || null;
